import React from "react";

const HomeIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
    >
      <path
        d="M31.6667 20V33.3333H8.33334V20H3.33334L20 5L36.6667 20H31.6667ZM25.8833 18.3833L24.1167 16.6167L14.1167 26.6167L15.8833 28.3833L25.8833 18.3833ZM17.7167 17.2833C17.3333 16.8833 16.8 16.6667 16.25 16.6667C15.7 16.6667 15.1667 16.8833 14.7833 17.2833C14.3833 17.6667 14.1667 18.2 14.1667 18.75C14.1667 19.3 14.3833 19.8333 14.7833 20.2167C15.1667 20.6167 15.7 20.8333 16.25 20.8333C16.8 20.8333 17.3333 20.6167 17.7167 20.2167C18.1167 19.8333 18.3333 19.3 18.3333 18.75C18.3333 18.2 18.1167 17.6667 17.7167 17.2833ZM25.2167 24.7833C24.8333 24.3833 24.3 24.1667 23.75 24.1667C23.2 24.1667 22.6667 24.3833 22.2833 24.7833C21.8833 25.1667 21.6667 25.7 21.6667 26.25C21.6667 26.8 21.8833 27.3333 22.2833 27.7167C22.6667 28.1167 23.2 28.3333 23.75 28.3333C24.3 28.3333 24.8333 28.1167 25.2167 27.7167C25.6167 27.3333 25.8333 26.8 25.8333 26.25C25.8333 25.7 25.6167 25.1667 25.2167 24.7833Z"
        fill="#14141E"
      />
    </svg>
  );
};

export default HomeIcon;
